export default "__VITE_ASSET__WKhNpUFRncUEuMcY8stSTw__"